// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"bbk_a"};